export default "__VITE_ASSET__BOjMqTpL__"